import { Controller }   from "stimulus";
import { getRequest }   from "@react/helpers/fetch"
import { patchRequest } from "@react/helpers/fetch"

export default class extends Controller {
  static targets = ["fieldContainer", "field", "receiverField", "showEye"];

  connect() {
    this.visible = false
  }

  toggleVisibility() {
    if (this.visible) {
      this.fieldTarget.innerText = '••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••'
      this.visible = false
      this.fieldTarget.removeAttribute('tooltip')
      this.showEyeTarget.setAttribute('tooltip', I18n.t("api_tokens.see_api_key"))
      this.showEyeTarget.innerHTML = "<i class='fas fa-eye'></i>"
    } else {
      getRequest(this.data.get("show-path"))
      .then(response => {
        this.fieldTarget.innerText = response.key
        this.fieldTarget.setAttribute('tooltip', I18n.t("api_tokens.click_to_copy"))
        this.showEyeTarget.setAttribute('tooltip', I18n.t("api_tokens.hide_api_key"))
        this.showEyeTarget.innerHTML = "<i class='fas fa-eye-slash'></i>"
        this.visible = true
      })
    }
  }

  refresh() {
    if (confirm(I18n.t("api_tokens.refresh_warning"))) {
      const url = this.data.get("refresh-path")
      patchRequest({ url }).then(() => {
        this.visible = false
        this.toggleVisibility()
        flashNotice(I18n.t("api_tokens.notice_refreshed"))
      })
    }
  }

  copyField() {
    if (!this.visible) return

    const fieldContainer = this.fieldContainerTarget
    navigator.clipboard.writeText(fieldContainer.innerText).then(() => {
      this.fieldTarget.setAttribute('tooltip', I18n.t("api_tokens.copied"))
      setTimeout(() => {
        this.fieldTarget.removeAttribute('tooltip')
      }, 1000)
    })
  }
}
